import script from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionFixtures.vue?vue&type=style&index=0&id=368e3b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368e3b68"]])

export default __exports__